/*
 * @Description: 项目动态
 * @Autor: lichao
 * @Date: 2021-12-02 11:55:00
 * @LastEditors: lichao
 * @LastEditTime: 2022-02-08 10:37:40
 */

import { useState, useEffect } from "react";
import { getdataLists } from "../../../api/home";
import "./index.less";
import {Pagination, Tabs} from "antd";
import TextImg from "../../../components/TextImg";

// 公益项目列表
const items = [
  {
    id: '23',
    label: '优秀学子及人才培养',
  },{
    id: '24',
    label: '困境未成年人帮扶',
  },{
    id: '25',
    label: '应急救灾及助困帮扶',
  },{
    id: '26',
    label: '情系银发助老爱心行动',
  },{
    id: '27',
    label: '“党建+公益”及其他',
  },
];
const newBannerList = [
  {
      "id": 1,
      "title": "优秀学子及人才培养",
      "text_image": "https://fund-town-1304488676.cos.ap-beijing.myqcloud.com/town_introduction/foundation/images/student.png",
      "url": "/project/941"
    },
  {
      "id": 2,
      "title": "困境未成年人帮扶",
      "text_image": "https://fund-town-1304488676.cos.ap-beijing.myqcloud.com/town_introduction/foundation/images/child.png",
      "url": "/project/934"
  },
  {
      "id": 3,
      "title": "应急救灾及助困帮扶",
      "text_image": "https://fund-town-1304488676.cos.ap-beijing.myqcloud.com/town_introduction/foundation/images/jiuzai.png",
      "url": "/project/939"
  },
  {
      "id": 4,
      "title": "情系银发助老爱心行动",
      "text_image": "https://fund-town-1304488676.cos.ap-beijing.myqcloud.com/town_introduction/foundation/images/old.png",
      "url": "/project/2811"
  },
  {
    "id": 5,
    "title": "“党建+公益”及其他",
    "text_image": "https://fund-town-1304488676.cos.ap-beijing.myqcloud.com/town_introduction/foundation/images/other.png",
    "url": "/project/2812"
},
]
// 切页
function itemRender(current, type, originalElement) {
  if (type === "prev") {
    return <span style={{marginRight: '10px'}}>上一页</span>;
  }
  if (type === "next") {
    return <span style={{marginLeft: '10px'}}>下一页</span>;
  }
  return originalElement;
}
const useDynamic = (page,id) => {
  const [dynamic, setDynamic] = useState({ list: [], pageInfo: {} });
  useEffect(() => {
    // 获取公告数据
    getdataLists({page:page,limit:4,location_id:id}).then((res) => {
      const { code, data } = res;
      if (code === 200) setDynamic(data);
    });
  }, [page,id]);
  return [dynamic];
};

const FoundationProject = () => {
  // 选中项
  const [activeIndex,setActiveIndex] = useState(0);

  const [page,setPage] = useState(1);
  const [locationId,setLocationId] = useState(23)

  const [dynamic] = useDynamic(page,locationId);
  // 副作
  useEffect(() => {
  }, []);
  // change tab Pane
  let changeTabPane = (val) => {
    setPage(1)
    setLocationId(val)
  }

  return (
    <div className="foundation-project w1200">
      <h3 className="project-title"><span>公益板块介绍</span></h3>
      <div className="welfare-project">
        <ul className="hidden-xs-only">
          {newBannerList.map((item, index) => (
            <li 
              key={item.id} 
              className={`sub-li ${activeIndex === index ? 'active' : ''}`}
              onMouseEnter={() => setActiveIndex(index)}
            >
              <a href={item.url} target="_blank">
                <img src={item.text_image} alt={item.title} />
                <div className="menk"></div>
                <div className="mask">
                  {item.title}
                  <button className="mask-button sub-more">查看更多</button>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div className="welfare-dt">
        <h3 className="project-title"><span>公益项目介绍</span></h3>
        <div>
          <Tabs 
            defaultActiveKey="23" 
            type="card" 
            onChange={changeTabPane}
            items={items.map((item) => ({
              key: item.id,
              label: item.label,
              children: (
                <div className="welfart-dt-content">
                  {dynamic.list.map((dy, dyi) => {
                    return (
                      <TextImg {...dy} meta='公益动态' pathname="/project" key={dyi}/>
                    );
                  })}
                  <Pagination
                    total={dynamic.pageInfo.dataTotal}
                    itemRender={itemRender}
                    pageSize={4}
                    current={dynamic.pageInfo.current}
                    showSizeChanger={false}
                    onChange={(page, pageSize) => {
                      setPage(page);
                    }}
                  />
                </div>
              ),
            }))}
          />
        </div>

      </div>
    </div>
  );
};

export default FoundationProject;
